import { Button, styled } from "@mui/material";

export const LoginButton = styled(Button)({
	width: "100%",
	height: "40px",
	display: "flex",
	gap: "5px",
	justifyContent: "center",
	alignItems: "center",
	backgroundColor: "#F8FBFD",
	border: "1px solid #E3E9ED",
	cursor: "pointer",
	color: "var(--inhouse-primary-dark)",
	fontWeight: 500,
	fontSize: "14px",
});

export const LoginSeparator = styled("span")({
	width: "100%",
	display: "flex",
	justifyContent: "space-evenly",
	alignItems: "center",
	gap: "10px",
	"::before": {
		content: "''",
		flex: "1 1 0",
		height: "1px",
		backgroundColor: "var(--inhouse-primary-dark)",
	},
	"::after": {
		content: "''",
		flex: "1 1 0",
		height: "1px",
		backgroundColor: "var(--inhouse-primary-dark)",
	},
});
